import useThemeStore from "../store/themeStore";
import { ThemeProps } from "../utils/theme";
import { CUSTOM_CARDS, ProductIds } from "../pages/components/FeaturedCardsCarousel";

const useCardList =()=>{
  const themes = useThemeStore((state) => state.theme as unknown as ThemeProps);

  // Filtering logic based on theme settings
  const visibleCards = CUSTOM_CARDS.filter((card: { productId: any; }) => {
    if (card.productId === ProductIds.dealSourcing && themes?.hideDealSourcing) return false;
    if (card.productId === ProductIds.legals && themes?.hideConveyancing) return false;
    if (card.productId === ProductIds.brokerage && themes?.hideMortgageBroker) return false;
    if (card.productId === ProductIds.lettings && themes?.hidePropertyManagement) return false;
    if (card.productId === ProductIds.refurbishment && themes?.hidePropertyRefurbishment) return false;
    if (card.productId === ProductIds.listings && themes?.hideSellProperty) return false;
    if (card.productId === ProductIds.companySetup && themes?.hideStartCompany) return false;
    if (card.productId === ProductIds.digitalPlus && themes?.hideDigitalPlus) return false;
    if (card.productId === ProductIds.furnishing && themes?.hideFurnishing) return false;
    if (card.productId === ProductIds.removals && themes?.hideRemovals) return false;
    if (card.productId === ProductIds.surveying && themes?.hideSurveying) return false;
    if (card.productId === ProductIds.housingAssociation && themes?.hideHousingAssociation) return false;
    if (card.productId === ProductIds.homeInsurance && themes?.hideHomeInsurance) return false;
    return true;
  });

  return visibleCards;
};

export default useCardList;
